// Service Worker Registration with Update Detection
// Includes guards for React StrictMode double-invocation and reload loops

let registration = null;
let updateCallback = null;
let isRegistered = false;
let isRefreshing = false;

export function setUpdateCallback(callback) {
  updateCallback = callback;
}

export async function registerServiceWorker() {
  // Guard against double invocation (React StrictMode)
  if (isRegistered) {
    console.log('[SW Registration] Already registered, skipping');
    return registration;
  }
  
  if (!('serviceWorker' in navigator)) {
    console.log('[SW Registration] Service workers not supported');
    return null;
  }

  isRegistered = true;

  try {
    registration = await navigator.serviceWorker.register('/service-worker.js', {
      updateViaCache: 'none' // Never use browser cache for SW updates
    });
    
    console.log('[SW Registration] Registered:', registration.scope);

    // Check for updates immediately
    registration.update();

    // Listen for new service worker installation
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
      console.log('[SW Registration] Update found, new worker installing...');

      newWorker.addEventListener('statechange', () => {
        console.log('[SW Registration] New worker state:', newWorker.state);
        
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          // New service worker is installed but waiting
          console.log('[SW Registration] New version available! Showing update prompt.');
          if (updateCallback) {
            updateCallback();
          }
        }
      });
    });

    // Listen for controller change (when skipWaiting is called)
    // Guard against multiple reloads
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (isRefreshing) {
        console.log('[SW Registration] Already refreshing, skipping reload');
        return;
      }
      isRefreshing = true;
      console.log('[SW Registration] Controller changed, reloading...');
      window.location.reload();
    });

    // Listen for messages from service worker
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'SW_UPDATED') {
        console.log('[SW Registration] Received update notification, version:', event.data.version);
      }
    });

    // Check for updates every 60 seconds
    setInterval(() => {
      if (registration) {
        registration.update();
      }
    }, 60000);

    return registration;
  } catch (error) {
    console.error('[SW Registration] Failed:', error);
    isRegistered = false; // Allow retry on error
    return null;
  }
}

export function skipWaiting() {
  if (registration && registration.waiting) {
    console.log('[SW Registration] Sending SKIP_WAITING to waiting worker');
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  } else {
    // Fallback: if no waiting worker, just reload to get latest
    console.log('[SW Registration] No waiting worker found, reloading page');
    if (!isRefreshing) {
      isRefreshing = true;
      window.location.reload();
    }
  }
}

export function checkForUpdates() {
  if (registration) {
    registration.update();
  }
}
